export default "__VITE_ASSET__CV1yt_FA__"